import PropTypes from 'prop-types';
import {
  Card,
  CardContent,
  CardHeader,
} from '@mui/material';
export const OverviewEmpty = (props) => {
  const { sx} = props;
  return (
    <Card sx={sx}>
      <CardHeader
      />
      <CardContent>
        <h5 style={{textAlign:'center'}}>Please specify the type and date to generate the data visualization.</h5>
      </CardContent>
    </Card>
  );
};

OverviewEmpty.propTypes = {
  sx: PropTypes.object
};
